<template>
    <div>
        <div class="form-group_up">
            <label class="form-label" for="name-f">{{ __t('SEARCH') }}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text border-right-0">
                        <i class="fal fa-democrat"></i>
                    </span>
                </div>

                <input
                    type="text"
                    v-model="search_txt"
                    id="filter_search"
                    class="form-control"
                    :placeholder="__t('SEARCH')"
                />

                <div class="input-group-append srch">
                    <button class="btn btn-primary shadow-0 waves-effect waves-themed" @click="send_search">
                        <i class="fal fa-search"></i>
                    </button>
                    <button
                        @click="toggle_filter"
                        type="button"
                        class="btn btn-outline-primary shadow-0 waves-effect waves-themed"
                    >
                        {{ __t('ADVANCED_FILTER') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-danger shadow-0 waves-effect waves-themed"
                        @click="clear_form"
                    >
                        <span class="fal fa-times mr-1"></span>
                        {{ __t('CLEAN_FILTER') }}
                    </button>
                </div>
            </div>
            <span class="help-block">{{ __t('SEARCH_HELPER') }}</span>
        </div>

        <div class="collapse show" id="imc_filter" v-if="is_show_filter">
            <div class="form-group js-stools-container-filters">
                <div class="d-flex flex-wrap">
                    <div class="flex-fill mt-2 mb-2">
                        <imc_select
                            filter_name="rest_id"
                            hidden_input="rest_id"
                            send_trigger_name="filter_stop_change"
                            items_url="internal/v1/catalog/restaurants"
                            active_filed_name="title"
                            active_filed_val="id"
                            :placeholder="__t('REST_FILTER')"
                            :active_id="active_rest_id"
                        />
                    </div>

                    <div class="flex-fill mt-2 mb-2">
                        <imc_select
                            filter_name="provider_id"
                            hidden_input="provider_inp"
                            send_trigger_name="filter_stop_change"
                            items_url="internal/providers/out"
                            active_filed_name="name"
                            active_filed_val="id"
                            :placeholder="__t('PROVIDER_FILTER')"
                            :active_id="active_provider_id"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Imc_select from "../../../sys/xml_fields/imc_select";

export default {
    name: "filter_stop",
    components: { Imc_select },

    props: {
        active_rest_id: {
            type: Number,
            default: 0
        },
        active_provider_id: {
            type: Number,
            default: 0
        },
        search_value: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            search_txt: this.search_value,
            is_active_filter: false
        };
    },

    computed: {
        is_show_filter() {
            return this.active_rest_id > 0 || this.is_active_filter;
        }
    },

    methods: {
        send_search() {
            EventBus.$emit('search_stop_called', this.search_txt);
        },

        clear_form() {
            EventBus.$emit('clean_stop_filter');
        },

        toggle_filter() {
            this.is_active_filter = !this.is_active_filter;
        }
    }
};
</script>

<style scoped>
</style>
